import React from 'react'
import { useTranslation } from 'react-i18next'
import { WidgetGuard } from 'features/types'
import { FetchErrorResponse } from 'api'
import { useDashboardWidgetData } from '../../../../hooks/useWidgetState'
import ErrorMessage from '../../../share/ErrorMessage'
import ErrorCode from '../../../../enums/ErrorCode'

const TopicInaccessibleGuard: WidgetGuard = ({ widgetId, children }) => {
  const widgetData = useDashboardWidgetData(widgetId)
  const { t } = useTranslation()

  if ((widgetData.error as FetchErrorResponse)?.status === ErrorCode.TOPIC_INACCESSIBLE_ERROR) {
    return <ErrorMessage>{t('topicInaccessible')}</ErrorMessage>
  }

  return children
}

export default TopicInaccessibleGuard
